<template>
  <div
    id="app"
    class="container-fluid p-0 m-0"
  >
    <LoginHeader v-if="!showFullHeader" />
    <Header v-if="showFullHeader" />
    <main class="w-100 ml-0 mr-0 mb-0">
      <router-view />
    </main>
    <bmgFooter />
  </div>
</template>

<script>
import LoginHeader from './components/LoginHeader'
import Header from './components/Header'
import bmgFooter from './components/Footer'
import 'gsap'
// import {CSSPlugin, AttrPlugin, TimelineMax} from 'gsap/all'
// const plugins = [ CSSPlugin, AttrPlugin ]

export default {
  name: 'App',
  data () {
    return {
      showHeader: !this.$store.state.useSecurity
    }
  },
  components: {
    LoginHeader,
    Header,
    bmgFooter
  },
  computed: {
    showFullHeader: function () {
      return this.showHeader
    //   // We only want to show the full header under two circumstances:
    //   //  1) We aren't using site security, or
    //   //  2) We are using site security AND the user has logged in
    //   if (!this.$store.state.useSecurity) {
    //     // Case 1
    //     console.log('We aren\'t using site security, so show the full header...')
    //     return true
    //   } else if (this.$root.isUserAlreadyLoggedIn()) {
    //     // Case 2
    //     console.log('We are using site security AND the user has logged in... so show the full header')
    //     return true
    //   }
    //   // Don't show the full header
    //   console.log('Don\'t show the full header yet...!')
    //   return false
    }
  },
  methods: {
    // pulse () {
    //   var _pulse = new TimelineMax({
    //     yoyo: true,
    //     paused: false,
    //     repeat: -1,
    //     repeatDelay: 0
    //   })
    //   _pulse.to('.pulse', 0.5, {scale: 1})
    //     .to('.pulse', 0.5, {scale: 1.1})
    //     .to('.pulse', 0.5, {scale: 1})
    //     .to('.pulse', 0.5, {scale: 1.1})
    // },
    changeHeader: function (show) {
      this.showHeader = show
    }
  },
  // beforeMount () {},
  mounted () {
    // this.pulse()
  }
  // beforeDestroy () {
  //   console.log('App.beforeDestroy()! Cleaning up...')
  //   this.$root.logout()
  //   // this.$firebase.auth().signOut().then(function() {
  //   //   // Sign-out successful.
  //   // }).catch(function(error) {
  //   //   // An error happened.
  //   // })
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
</style>
